import React from "react";
import { Table } from "react-bootstrap";

interface SubtopicInfoTableProps {
  subtopicInfo: { subject_name?: string; topic_name?: string; subtopic_name?: string } | null;
}

/**
 * Subtopic Info Table Component
 * Displays subject, topic, and subtopic names in a simple table format
 */
const SubtopicInfoTable: React.FC<SubtopicInfoTableProps> = ({ subtopicInfo }) => {
  if (!subtopicInfo) return null;
  
  return (
    <Table bordered size="sm" className="mb-3">
      <tbody>
        <tr>
          <td>{subtopicInfo.subject_name || "--"}</td>
          <td>{subtopicInfo.topic_name || "--"}</td>
          <td>{subtopicInfo.subtopic_name || "--"}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default SubtopicInfoTable;
